export const programsTableHeadStyles = {
  flexDirection: 'row',
  p: '0px 12px 9px',
  borderTop: 1,
  borderBottom: 1,
  borderColor: ({ palette }) => palette.border.default,
  position: 'sticky',
  top: 0,
  zIndex: 1,
  backgroundColor: ({ palette }) => palette.background.default,

  '& .MuiTableSortLabel-root': {
    gap: 0.5,
    textWrap: 'wrap',

    '& .sort-icon-wrapper': {
      alignSelf: 'flex-start',
      mt: 0.25,
    },
  },
};

export const headCellsWrapperStyles = {
  flexDirection: 'row',
  flex: 1,
};

const headCellStyles = {
  p: 2,
};

export const labelStyles = {
  textAlign: 'end',
  fontWeight: 600,
  lineHeight: '16.41px',
};

export const getHeadCellStyles = customStyles => ({ ...headCellStyles, ...customStyles });
